import { IsInt, IsOptional, IsPositive, IsString } from 'class-validator'

export class PatchLotInitialCommentDto {
  @IsString()
  @IsOptional()
  comment?: string | null

  @IsInt()
  @IsPositive()
  @IsOptional()
  typeId?: number | null
}
